<template>
  <div class="c-accordion">
    <div class="c-accordion-header" :class="props.titleClasses" @click="isCollapsed = !isCollapsed">
      <p class="c-accordion-title">{{props.title}}</p>
      <se-icon :name="isCollapsed ? 'chevron-down' : 'chevron-up'" :size="24"/>
    </div>
    <slot v-if="!isCollapsed" />
  </div>
</template>

<script setup lang="ts">
import SeIcon from "@/src/shared/ui-kit/icon/Icon.vue";
import {ref} from "vue";

const props = withDefaults(defineProps<{
  title: string;
  titleClasses: string;
}>(), {
  titleClasses: ''
});

const isCollapsed = ref(true)
</script>

<script lang="ts">
export default {
  name: 'SeAccordion',
};
</script>
